export const messages = {
  en: {
    userDetailIntegral: {
      id: 'ID',
      accountName: 'Account Name',
      objType: 'Object Type',
      merchant: 'Merchant',
      user: 'User',
      userId: 'User ID',
      tel: 'Phone',
      integralAmount: 'Integral Amount'
    }
  },
  zh: {
    userDetailIntegral: {
      id: '编号',
      accountName: '账户名称',
      objType: '对象类型',
      merchant: '商户',
      user: '用户',
      userId: '用户编号',
      tel: '手机号',
      integralAmount: '积分数'
    }
  }
}